module.exports = __webpack_public_path__ + "img/des_jita_04.64a8cdbd.jpg";